// eslint-disable-next-line import/no-unresolved
import { Theme as themePrimary } from 'exo_theme_primary';
import { themes } from './themeList';
import { move } from './themeUtils';


const toVersion03 = [
  ['productBrowse', 'automotive.ProductBrowseCarousel'],
  ['marketingInfoTabs', 'automotive.marketingInfoTabs'],
  ['configurator', 'automotive.Configurator'],
  ['priceBar', 'automotive.PriceBar'],
  ['optionButton.normal.border', 'automotive.savedConfiguration.border'],
  ['savedConfiguration.shadow', 'automotive.savedConfiguration.shadowColor'],
  ['savedConfiguration.border', 'automotive.savedConfiguration.borderColor'],
  ['tile', 'automotive.Tile'],
  ['tile.colour', 'automotive.Tile.color'],
  ['optionButton', undefined]
];


const verifyThemeVersion = (t) => {
  if (t.version !== '0.2') {
    // eslint-disable-next-line no-console
    console.warn(`Theme '${t.name}' uses an old theme format (${t.version ?? '0.1'} vs current 0.2)`);
    if (!t.version || t.version === '0.1') {
      console.warn('- to upgrade from 0.1 to 0.2, see https://github.ibm.com/ixliberty/ixl-frontend/pull/737');
    }

    if (!t.version || t.version === '0.1' || t.version === '0.2') {
      console.warn('- to upgrade to 0.3, apply the following transformations');
      for (const [from, to] of toVersion03) {
        console.warn(`  - ${from} -> ${to ?? 'DELETE'}`);
        move(t, from, to);
      }
    }
  }
}

const handler = {
  get: (target, prop) => {
    if (typeof window !== 'undefined' && window.exo_theme !== undefined) {
      return themes[window.exo_theme][prop];
    }
    return target[prop];
  }
};

// Verify theme versions
verifyThemeVersion(themePrimary);
themes.filter(t => t.name).forEach(t => verifyThemeVersion(t));

export default new Proxy(themePrimary, handler)
